module.exports = __webpack_public_path__ + "img/8-Intersection 2.5bcb74e4.png";